import { endPoints } from 'api/';
import { GET_DEFAULT_STATUSES } from 'actions/types';

/**
 * @description Get a list of all default statuses.
 */
function query() {
  const query = { where: { is_deleted: false } };
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: GET_DEFAULT_STATUSES,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const status = await apiClient(
          endPoints.GET_DEFAULT_STATUSES,
          {},
          query,
        );
        return status;
      },
    };
    dispatch(action);
  };
}

export default query;
